import { ServiceDefinition } from '@pershing/pershing-core';

export class TradingOrderStatusServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    // TODO - check this name and make sure it is correct
    uri: string = 'trading/orders';
    version: string = 'v1';
    family: string = 'pershing';
    appName: string = 'order-status';
    serviceName: string = 'app';
    mnemonic: string = 'nxp';

    static getInstance(platform: string): ServiceDefinition {
        if (!TradingOrderStatusServiceDefinition.instance) {
            TradingOrderStatusServiceDefinition.instance = new TradingOrderStatusServiceDefinition();
            if (platform === 'retail') {
                TradingOrderStatusServiceDefinition.instance.family = 'netxinvestor';
                TradingOrderStatusServiceDefinition.instance.mnemonic = 'nxc';
            }
        }
        return TradingOrderStatusServiceDefinition.instance;
    }

    
    private constructor() {
        //intentional empty constructor
    }
}
